import { useState } from "react";
import MetasMercantil from "../../components/MetasMercantil/MetasMercantil";
import MetasServicoExtra from '../../components/MetasServicoExtra/MetasServicoExtra';
import NotifierPopup from "../../components/NotifierPopup/NotifierPopup";

export default function MetasExtranetAdm(){
    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });

    const handleServicoNotifier = (ok, msg) => {
        setNotify({isActive: true, isSuccessful: ok, message: msg});
    };

    const handleMercantilNotifier = (ok, msg) => {
        setNotify({isActive: true, isSuccessful: ok, message: msg});
    };

    return(
        <>
        {notify.isActive && 
            <NotifierPopup notify={notify} setNotify={setNotify}/>
        }

        <MetasServicoExtra setNotifier={handleServicoNotifier}/>

        <MetasMercantil setNotifier={handleMercantilNotifier}/>
        </>
    );
}